import { SITE } from "../data/site";
import { LogoMark, IconInstagram } from "./Icons";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-coal2 pb-24 md:pb-0" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <a href="/" className="flex items-center gap-2.5" data-testid="footer-logo-link" aria-label="Burger Blenger — beranda">
          <LogoMark className="h-10 w-10" />
          <span className="pt-1 font-display text-3xl tracking-wide text-cream">
            BURGER<span className="text-blood">BLENGER</span>
          </span>
        </a>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-sand">
          Lapak burger jalanan legendaris dari Barito–Blok M, Jakarta Selatan.
          Bun dan patty homemade, saus luber, porsi bikin blenger — sejak 2004.
        </p>
        <p className="mt-4 font-display text-lg tracking-[0.2em] text-cheddar">
          “{SITE.slogan}”
        </p>
      </div>

      <div className="md:col-span-3">
        <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-cream">Outlet Pusat</h2>
        <address className="mt-4 text-sm not-italic leading-relaxed text-sand" data-testid="footer-address">
          {SITE.name}
          <br />
          {SITE.address.street}
          <br />
          {SITE.address.locality}
          <br />
          {SITE.address.region}, {SITE.address.country}
        </address>
      </div>

      <div className="md:col-span-2">
        <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-cream">Jelajahi</h2>
        <ul className="mt-4 space-y-3 text-sm text-sand">
          <li><a href="/menu/" data-testid="footer-link-menu" className="transition-colors hover:text-cheddar">Menu</a></li>
          <li><a href="/tentang/" data-testid="footer-link-tentang" className="transition-colors hover:text-cheddar">Tentang</a></li>
          <li><a href="/lokasi/" data-testid="footer-link-lokasi" className="transition-colors hover:text-cheddar">Lokasi</a></li>
          <li><a href="/faq/" data-testid="footer-link-faq" className="transition-colors hover:text-cheddar">FAQ</a></li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h2 className="font-mono text-xs uppercase tracking-[0.2em] text-cream">Ikuti Kami</h2>
        <a
          href={SITE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="mt-4 inline-flex items-center gap-2 text-sm text-sand transition-colors hover:text-cheddar"
        >
          <IconInstagram className="h-5 w-5" />
          {SITE.instagramHandle}
        </a>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.18em] text-sand/70 sm:flex-row sm:items-center sm:justify-between">
        <span>© 2026 {SITE.name} • Jakarta Selatan</span>
        <span>Blenger itu tujuan, bukan efek samping.</span>
      </div>
    </div>
  </footer>
);
